export default __webpack_public_path__ + "static/media/Group-8.d483728b.png";